'use strict';

const h = require('phy');

module.exports = ({ shippingCharge }) =>
  h(
    '.goods-shipping-modal',
    h('span.goods-shipping-modal-label', ' Shipping '),
    h('span.goods-shipping-modal-value.c-txt-price', shippingCharge)
  );
